import React, { Component } from "react";
import { connect } from "react-redux";
import { fromJS } from "immutable";
import { bindActionCreators } from "redux";

import ActionGet from "../../store/action/TemplateChecker/Fetch";
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import ActionGetAllDivision from "../../store/action/Division/FetchAll";
import ActionGetAllSender from "../../store/action/Sender/FetchAll";
import CustomGrid from "../../infra/components/grid/custom-grid-without-search";
import "../../source/util.css";
import {
    ClientId,
    PrevilageId,
} from "../../helper/HelperAuth";
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import TextInputField from "../../infra/components/formInput/CustomTextInput";
import ActionGetAccessModuleIdAction from "../../store/action/AccessModule/FetchActionDispatch";

class Page extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: "Check Template Id",
            formSearch: fromJS({
                search: "",
            }),
            search: fromJS([
                {
                    widthClass: "col-sm-12",
                    id: "search",
                    placeholder: "Search",
                    label: "",
                    value: "",
                },
            ]),
            searchForm: fromJS({
                "client-id": "",
                "division-id": "",
                "sender-id": "",
                "template-name": "",
            }),
            columns: [
                { className: "", field: "id", caption: "Template ID" },
                { className: "", field: "name", caption: "Template Name" },
                { className: "", field: "category", caption: "Category" },
                { className: "", field: "status", caption: "Status" },
                { className: "", field: "waba-id", caption: "Waba ID" },
            ],

            columnsView: [
                { className: "", field: "id", caption: "Template ID" },
                { className: "", field: "name", caption: "Template Name" },
                { className: "", field: "category", caption: "Category" },
                { className: "", field: "status", caption: "Status" },
                { className: "", field: "waba-id", caption: "Waba ID" },
            ],

            errors: fromJS({}),
            actionId: "",
        };

        this.showContent = this.showContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleFind = this.handleFind.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
        this.changeAction();
    }

    async componentDidMount() {
        this.props.actionGetAllClient();
    }

    changeAction() {
        let dataAkses = this.props.accessmoduleaction;
        if (dataAkses) {
            let varActionId = dataAkses.get("action-id");
            this.setState({ actionId: varActionId });
        }
    }

    handleSearch(obj) {
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    };

    refreshGrid(page, search) {
        this.handleFindSearch(page);
    }

    handleChange(field, value, label) {
        const { searchForm } = this.state;
        let formVal = searchForm;
        formVal = formVal.set(field, value);

        if (field === "client-id") {
            this.props.actionGetAllDivision(value);
            this.props.actionGetAllSender(value);
        }

        if (field === "division-id") {
            this.props.actionGetAllSender(searchForm.get("client-id"), value);
        }

        this.setState({ searchForm: formVal });
    }

    handleFind() {
        this.handleFindSearch(1);
    }

    async handleFindSearch(page) {
        const { searchForm } = this.state;
        let client_id = searchForm.get("client-id");
        let division_id = searchForm.get("division-id");
        let sender_id = searchForm.get("sender-id");
        let template_name = searchForm.get("template-name");

        if (PrevilageId != 1 && client_id == "") client_id = ClientId;
        if (PrevilageId == 1 && client_id == "") client_id = 0;

        let bodyFind = {
            "client-id": client_id,
            "division-id": division_id,
            "sender-id": sender_id,
            "template-name": template_name,
        };

        await this.props.actionGet(page, bodyFind);
    }

    showContent() {
        const items = this.props.facebookTemplateData
            ? fromJS(this.props.facebookTemplateData)
            : fromJS({});
        let col = this.state.columnsView;
        if (PrevilageId == 1) col = this.state.columns;
        return (
            <CustomGrid
                title="Check Template Id"
                columns={col}
                items={items}
                headerAction={this.state.headerAction}
                search={this.state.search}
            ></CustomGrid>
        );
    }

    render() {
        const { searchForm, errors, title } = this.state;
        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>{title}</h4>
                </div>
                <div className="card">
                    <div className="body">
                        <div className="row">
                            <span className="col-sm-2 pt-2 required">Client</span>
                            <div className="col-sm-10">
                                <ComboboxInput
                                    field="client-id"
                                    value={searchForm.get("client-id")}
                                    options={fromJS({
                                        source: this.props.clientall,
                                        value: "client-id",
                                        label: "client-name",
                                    })}
                                    onChange={(field, value, label) =>
                                        this.handleChange(field, value, label)
                                    }
                                    placeholder="Client"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <span className="col-sm-2 pt-2">Division</span>
                            <div className="col-sm-10">
                                <ComboboxInput
                                    field="division-id"
                                    value={searchForm.get("division-id")}
                                    options={fromJS({
                                        source: this.props.divisionall,
                                        value: "division-id",
                                        label: "division-name",
                                    })}
                                    onChange={(field, value, label) =>
                                        this.handleChange(field, value, label)
                                    }
                                    placeholder="Division"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <span className="col-sm-2 pt-2 required">Sender</span>
                            <div className="col-sm-10">
                                <ComboboxInput
                                    field="sender-id"
                                    value={searchForm.get("sender-id")}
                                    options={fromJS({
                                        source: this.props.senderall,
                                        value: "sender-id",
                                        label: "sender-name",
                                    })}
                                    onChange={(field, value, label) =>
                                        this.handleChange(field, value, label)
                                    }
                                    placeholder="Sender"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <span className="col-sm-2 pt-2 required">Template Name</span>
                            <div className="col-sm-10">
                                <TextInputField
                                    className="form-control"
                                    field="template-name"
                                    value={searchForm.get("template-name")}
                                    onChange={(field, value) =>
                                        this.handleChange(field, value, "")
                                    }
                                    placeholder="template-name"
                                    disabled={false}
                                    hasError={errors.has("Template Name")}
                                />
                            </div>
                        </div>
                        <div className="row no-margin-bottom">
                            <span className="col-sm-2 pt-2"></span>
                            <div className="col-sm-2">
                                <button
                                    type="button"
                                    className="btn btn-wide btn-success"
                                    onClick={this.handleFind}
                                >
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.showContent()}
            </div>
        );
    }
}

export default connect(
    (state) => {
        return {
            facebookTemplateData: state.user.facebookTemplateData,
            clientall: state.user.clientall,
            divisionall: state.user.divisionall,
            senderall: state.user.senders,
            accessmoduleaction: state.user.accessmoduleaction,
        };
    },
    (dispatch) =>
        bindActionCreators(
            {
                actionGet: ActionGet,
                actionGetAllClient: ActionGetAllClient,
                actionGetAllDivision: ActionGetAllDivision,
                actionGetAllSender: ActionGetAllSender,
                actionGetAccessModuleIdAction: ActionGetAccessModuleIdAction,
            },
            dispatch
        )
) (Page);
